// Import SEO images - Add your page-specific images here
import homeOgImage from '../assets/images/seo/home-og-image.jpg';
import whatWeDoOgImage from '../assets/images/seo/what-we-do-og-image.jpg';
import howToJoinOgImage from '../assets/images/seo/how-to-join-og-image.jpg';
import libraryOgImage from '../assets/images/seo/library-og-image.jpg';
import defaultOgImage from '../assets/images/seo/og-image.jpg';

// SEO Data for all pages
export const seoData = {
  home: {
    title: 'Systematic Quantitative Strategies',
    content:
      'MarQ Capital is a London-based quantitative strategy provider delivering systematic, macro-agnostic strategies for institutional portfolios through its proprietary engine, SwingVision.',
    keywords:
      'quantitative strategies, systematic trading, algorithmic trading, SwingVision, institutional investors, AMC, MarQ Capital, UK financial services',
    canonical: '/',
    ogType: 'website',
    ogImage: homeOgImage,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'FinancialService',
      name: 'MarQ Capital Limited',
      description:
        'London-based quantitative strategy provider delivering systematic, institutional-grade algorithmic trading strategies.',
      url: 'https://mqcapital.co.uk',
      logo: 'https://mqcapital.co.uk/logo512.png',
      image: 'https://mqcapital.co.uk/og-image.jpg',
      telephone: '+44 20 4587 3860',
      email: 'inquiries@mqcapital.co.uk',
      address: {
        '@type': 'PostalAddress',
        streetAddress:
          'Level 30, The Leadenhall Building, 122 Leadenhall Street',
        addressLocality: 'London',
        postalCode: 'EC3V 4AB',
        addressCountry: 'GB',
        addressRegion: 'England'
      },
      foundingDate: '2022',
      founder: {
        '@type': 'Person',
        name: 'Luís Marques'
      },
      serviceType: [
        'Quantitative Strategies',
        'Systematic Trading',
        'Algorithmic Trading'
      ],
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      currenciesAccepted: ['GBP', 'USD', 'EUR'],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Quantitative Strategies',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Actively Managed Certificates (AMC)',
              description:
                'Access to MarQ Capital systematic strategies via custodian-segregated AMCs'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Separately Managed Accounts (SMA)',
              description:
                'Direct execution via regulated broker platforms, with the client retaining full custody'
            }
          }
        ]
      },
      sameAs: [
        'https://www.linkedin.com/company/mqcapital',
        'https://twitter.com/mqcapital',
        'https://mqcapital.co.uk'
      ]
    }
  },

  whatWeDo: {
    title: 'What We Do - Systematic Quantitative Strategies',
    content:
      "Discover MarQ Capital's systematic quantitative strategies, built and executed through its proprietary engine, SwingVision.",
    keywords:
      'quantitative strategies, systematic trading, algorithmic trading, financial technology, SwingVision',
    canonical: '/what-we-do',
    ogType: 'website',
    ogImage: whatWeDoOgImage
  },

  aboutUs: {
    title: 'About Us - Institutional Quantitative Strategies',
    content:
      'London-based Quantitative Strategy Provider delivering institutional-grade algorithmic trading through SwingVision. FCA authorised and regulated.',
    keywords:
      'about MarQ Capital, quantitative strategy provider, algorithmic trading, SwingVision, FCA regulated, institutional trading, systematic strategies',
    canonical: '/about-us',
    ogType: 'website',
    ogImage: defaultOgImage
  },

  strategies: {
    title: 'Investment Strategies - Systematic Trading Solutions',
    content:
      "Discover MarQ Capital's systematic quantitative trading strategies and algorithmic investing. Technology-driven solutions for portfolio growth.",
    keywords:
      'investment strategies, systematic trading, quantitative strategies, algorithmic trading, trading technology, MarQ Capital strategies, portfolio management',
    canonical: '/strategies',
    ogType: 'website',
    ogImage: defaultOgImage
  },

  investmentPrograms: {
    title: 'Quantitative Strategies - Investment Programs',
    content:
      "Explore MarQ Capital's quantitative strategies and investment programs. Access portfolio management, Sentinel Signals, and tailored solutions.",
    keywords:
      'quantitative strategies, investment account, portfolio management, investment solutions, financial planning, wealth building',
    canonical: '/investment-programs',
    ogType: 'website',
    ogImage: defaultOgImage
  },

  howToJoin: {
    title: 'How to Join - Careers & Opportunities',
    content:
      'Join MarQ Capital. Explore careers in finance, technology, and investment management. Learn about our hiring process and company culture.',
    keywords:
      'careers, jobs, hiring, recruitment, financial careers, investment careers, MarQ Capital jobs, finance opportunities',
    canonical: '/how-to-join',
    ogType: 'website',
    ogImage: howToJoinOgImage
  },

  library: {
    title: 'Resource Library - Market Analysis & Insights',
    content:
      "Access MarQ Capital's library of market analysis, investment insights, trading strategies, and financial commentary. Expert perspectives on global markets.",
    keywords:
      'market analysis, investment insights, trading strategies, financial commentary, market research, investment library, MarQ Capital insights, financial analysis',
    canonical: '/library',
    ogType: 'website',
    ogImage: libraryOgImage,
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'MarQ Capital Resource Library',
        description:
          'Comprehensive collection of market analysis, investment insights, and financial research',
        url: 'https://mqcapital.co.uk/library',
        publisher: {
          '@type': 'Organization',
          name: 'MarQ Capital Limited',
          logo: {
            '@type': 'ImageObject',
            url: 'https://mqcapital.co.uk/logo512.png'
          }
        },
        inLanguage: 'en-GB',
        keywords:
          'market analysis, investment insights, trading strategies, financial commentary'
      },
      {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: 'MarQ Capital - Company Introduction',
        description:
          'Introduction to MarQ Capital - A London-based quantitative strategy provider delivering institutional-grade algorithmic trading solutions.',
        thumbnailUrl:
          'https://www.dropbox.com/scl/fi/ra9e6lqlf3n1wlqf9o5q9/MarQ-intro.mp4?rlkey=sr7b1m14c3tr5ks1rzkgnl5b6&st=ficeba75&raw=1',
        uploadDate: '2026-01-01',
        contentUrl:
          'https://www.dropbox.com/scl/fi/ra9e6lqlf3n1wlqf9o5q9/MarQ-intro.mp4?rlkey=sr7b1m14c3tr5ks1rzkgnl5b6&st=ficeba75&raw=1',
        embedUrl:
          'https://www.dropbox.com/scl/fi/ra9e6lqlf3n1wlqf9o5q9/MarQ-intro.mp4?rlkey=sr7b1m14c3tr5ks1rzkgnl5b6&st=ficeba75&raw=1',
        duration: 'PT2M30S',
        publisher: {
          '@type': 'Organization',
          name: 'MarQ Capital Limited',
          logo: {
            '@type': 'ImageObject',
            url: 'https://mqcapital.co.uk/logo512.png'
          }
        },
        potentialAction: {
          '@type': 'WatchAction',
          target:
            'https://www.dropbox.com/scl/fi/ra9e6lqlf3n1wlqf9o5q9/MarQ-intro.mp4?rlkey=sr7b1m14c3tr5ks1rzkgnl5b6&st=ficeba75&raw=1'
        },
        inLanguage: 'en-GB'
      }
    ]
  },

  news: {
    title: 'News & Insights - Latest Market Updates',
    content:
      'Latest news and market insights from MarQ Capital. Expert investment analysis and financial commentary on global markets and trends.',
    keywords:
      'financial news, market insights, investment analysis, market updates, financial commentary, MarQ Capital news',
    canonical: '/news',
    ogType: 'website',
    ogImage: libraryOgImage
  },

  contact: {
    title: 'Contact Us - Get in Touch',
    content:
      'Contact MarQ Capital for enquiries about our systematic quantitative strategies or for general information.',
    keywords:
      'contact MarQ Capital, quantitative strategies enquiry, institutional investors, MarQ Capital London',
    canonical: '/contact',
    ogType: 'website',
    ogImage: defaultOgImage,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contact MarQ Capital',
      description:
        'Contact page for MarQ Capital Limited - Systematic Quantitative Strategies',
      url: 'https://mqcapital.co.uk/contact',
      mainEntity: {
        '@type': 'Organization',
        name: 'MarQ Capital Limited',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          telephone: '+44 20 4587 3860',
          email: 'inquiries@mqcapital.co.uk',
          availableLanguage: ['English'],
          areaServed: 'GB',
          hoursAvailable: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '17:00'
          }
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress:
            'Level 30, The Leadenhall Building, 122 Leadenhall Street',
          addressLocality: 'London',
          postalCode: 'EC3V 4AB',
          addressCountry: 'GB',
          addressRegion: 'England'
        }
      }
    }
  },

  // Investment Programs / Strategies
  strandQ: {
    title: 'Strand Q - Quantitative Investment Strategy',
    content:
      'Strand Q is a systematic quantitative strategy from MarQ Capital, delivering consistent performance through advanced algorithmic trading.',
    keywords:
      'Strand Q, quantitative strategy, algorithmic trading, systematic investing, MarQ Capital, investment program, quantitative trading',
    canonical: '/strategies/strand-q',
    ogType: 'website',
    ogImage: defaultOgImage,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Strand Q Investment Strategy',
      description:
        'Systematic quantitative investment strategy delivering consistent performance through advanced algorithmic trading',
      provider: {
        '@type': 'Organization',
        name: 'MarQ Capital Limited',
        url: 'https://mqcapital.co.uk'
      },
      serviceType: 'Investment Management',
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      category: 'Financial Services',
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: 'GBP'
      }
    }
  },

  merin: {
    title: 'Merin - Advanced Trading Strategy',
    content:
      'Merin is an advanced quantitative trading strategy from MarQ Capital for sophisticated investors seeking diversified market exposure and risk-adjusted returns.',
    keywords:
      'Merin, trading strategy, quantitative investing, algorithmic trading, MarQ Capital, investment program, diversified strategy',
    canonical: '/strategies/merin',
    ogType: 'website',
    ogImage: defaultOgImage,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Merin Investment Strategy',
      description:
        'Advanced quantitative trading strategy designed for sophisticated investors seeking diversified market exposure',
      provider: {
        '@type': 'Organization',
        name: 'MarQ Capital Limited',
        url: 'https://mqcapital.co.uk'
      },
      serviceType: 'Investment Management',
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      category: 'Financial Services',
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: 'GBP'
      }
    }
  },

  dravon: {
    title: 'Dravon - Dynamic Investment Strategy',
    content:
      'Dravon is a dynamic quantitative strategy from MarQ Capital, using advanced algorithms to capture market opportunities across multiple asset classes.',
    keywords:
      'Dravon, dynamic strategy, quantitative trading, algorithmic investing, MarQ Capital, investment program, multi-asset strategy',
    canonical: '/strategies/dravon',
    ogType: 'website',
    ogImage: defaultOgImage,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Dravon Investment Strategy',
      description:
        'Dynamic quantitative investment strategy utilizing advanced algorithms to capture market opportunities',
      provider: {
        '@type': 'Organization',
        name: 'MarQ Capital Limited',
        url: 'https://mqcapital.co.uk'
      },
      serviceType: 'Investment Management',
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      category: 'Financial Services',
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: 'GBP'
      }
    }
  },

  globalMacro: {
    title: 'Global Macro - Macro Investment Strategy',
    content:
      'Global Macro is a macroeconomic investment strategy from MarQ Capital, capitalizing on global economic trends and market cycles with systematic analysis.',
    keywords:
      'Global Macro, macro strategy, macroeconomic investing, global markets, MarQ Capital, investment program, macro trading',
    canonical: '/strategies/global-macro',
    ogType: 'website',
    ogImage: defaultOgImage,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Global Macro Investment Strategy',
      description:
        'Comprehensive macroeconomic investment strategy analyzing and capitalizing on global economic trends',
      provider: {
        '@type': 'Organization',
        name: 'MarQ Capital Limited',
        url: 'https://mqcapital.co.uk'
      },
      serviceType: 'Investment Management',
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      category: 'Financial Services',
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: 'GBP'
      }
    }
  },

  // Legal Pages
  privacyPolicy: {
    title: 'Privacy Policy - Data Protection & Privacy',
    content:
      "Read MarQ Capital's privacy policy to understand how we collect, use, and protect your personal data in compliance with GDPR and UK data protection laws.",
    keywords:
      'privacy policy, data protection, GDPR compliance, personal data, privacy rights',
    canonical: '/legal/privacy-policy',
    ogImage: defaultOgImage,
    noindex: false
  },

  termsOfUse: {
    title: 'Terms of Use - Legal Terms & Conditions',
    content:
      "Review MarQ Capital's terms of use for our website and services. Understand your rights and obligations when using our investment services and platform.",
    keywords:
      'terms of use, legal terms, terms and conditions, service agreement',
    canonical: '/legal/terms-of-use',
    ogImage: defaultOgImage,
    noindex: false
  },

  taxStrategy: {
    title: 'Tax Strategy - Corporate Tax Approach',
    content:
      "Learn about MarQ Capital's tax strategy and commitment to responsible tax practices and compliance with UK corporation tax requirements.",
    keywords: 'tax strategy, corporate tax, tax compliance, UK corporation tax',
    canonical: '/legal/tax-strategy',
    ogImage: defaultOgImage,
    noindex: false
  },

  // CSR Page
  csr: {
    title: 'Corporate Social Responsibility - Our Commitment to Society',
    content:
      "Learn about MarQ Capital's CSR initiatives and commitment to sustainable business practices, ethical operations, and positive social impact.",
    keywords:
      'corporate social responsibility, CSR, sustainable finance, ethical investment, MarQ Capital CSR, responsible business, charitable giving',
    canonical: '/about-us/csr',
    ogType: 'website',
    ogImage: defaultOgImage
  },

  // Trading Business Vision Page
  tradingBusiness: {
    title: 'Trading Business Vision - Our Strategic Direction',
    content:
      "Discover MarQ Capital's trading business vision. Our purpose-driven, people-first approach and long-term mindset shape our quantitative trading operations.",
    keywords:
      'trading vision, business strategy, quantitative trading, algorithmic trading, MarQ Capital strategy, trading technology, systematic trading',
    canonical: '/strategies/trading-business-vision',
    ogType: 'website',
    ogImage: defaultOgImage
  },

  // AMC Page
  amc: {
    title: 'AMC - Actively Managed Certificates',
    content:
      "Explore MarQ Capital's Actively Managed Certificates (AMC) - a flexible, institutional-grade investment vehicle built on systematic strategies.",
    keywords:
      'AMC, actively managed certificates, investment vehicle, structured products, MarQ Capital, portfolio management, institutional investment',
    canonical: '/strategies/amc',
    ogType: 'website',
    ogImage: defaultOgImage
  },

  // How to Join Sub-pages
  internship: {
    title: 'Internship Programme - Start Your Career',
    content:
      'Apply for a MarQ Capital internship in quantitative finance, algorithmic trading, and investment management. Gain hands-on experience with expert mentorship.',
    keywords:
      'internship, finance internship, quant internship, investment internship, MarQ Capital internship, graduate programme, career start',
    canonical: '/how-to-join/internship',
    ogType: 'website',
    ogImage: howToJoinOgImage
  },

  interview: {
    title: 'Interview Process - What to Expect',
    content:
      "Learn about MarQ Capital's interview process. Understand our recruitment approach, what we look for, and how to prepare for a successful application.",
    keywords:
      'interview process, job interview, recruitment process, MarQ Capital interview, finance interview, quant interview preparation',
    canonical: '/how-to-join/interview',
    ogType: 'website',
    ogImage: howToJoinOgImage
  },

  preparingInterview: {
    title: 'Preparing for Your Interview - Tips & Guidance',
    content:
      'Get expert tips on preparing for your MarQ Capital interview. Learn the skills we look for and how to demonstrate your potential effectively.',
    keywords:
      'interview preparation, interview tips, finance interview, MarQ Capital recruitment, job application tips',
    canonical: '/how-to-join/interview/preparing-for-interview',
    ogType: 'website',
    ogImage: howToJoinOgImage
  },

  ukRecruitmentPolicy: {
    title: 'UK Recruitment Policy - Data Privacy Notice',
    content:
      "Read MarQ Capital's UK Recruitment Policy. Understand how your personal data is processed during recruitment under UK GDPR regulations.",
    keywords:
      'UK recruitment policy, recruitment data privacy, candidate data protection, GDPR recruitment',
    canonical: '/how-to-join/uk-recruitment-policy',
    ogType: 'website',
    ogImage: defaultOgImage,
    noindex: false
  },

  euRecruitmentPolicy: {
    title: 'EU Recruitment Policy - Data Privacy Notice',
    content:
      "Read MarQ Capital's EU Recruitment Policy. Understand how your personal data is processed during recruitment under EU GDPR regulations.",
    keywords:
      'EU recruitment policy, recruitment data privacy, candidate data protection, EU GDPR recruitment',
    canonical: '/how-to-join/eu-recruitment-policy',
    ogType: 'website',
    ogImage: defaultOgImage,
    noindex: false
  },

  // Legal Pages
  legal: {
    title: 'Legal Information - Policies & Compliance',
    content:
      "Access MarQ Capital's legal documents: terms, privacy, cookie policy, and regulatory disclosures. Fully compliant with UK financial regulations.",
    keywords:
      'legal information, terms and conditions, privacy policy, cookie policy, financial regulation, compliance, FCA, MarQ Capital legal',
    canonical: '/legal',
    ogType: 'website',
    ogImage: defaultOgImage
  },

  cookiePolicy: {
    title: 'Cookie Policy - How We Use Cookies',
    content:
      "Read MarQ Capital's Cookie Policy. Understand how we use cookies and similar technologies on our website and how you can manage your cookie preferences.",
    keywords:
      'cookie policy, cookies, tracking cookies, website cookies, cookie preferences, GDPR cookies',
    canonical: '/legal/cookie-policy',
    ogImage: defaultOgImage,
    noindex: false
  },

  importantDisclosures: {
    title: 'Important Disclosures - Risk & Legal Notices',
    content:
      "Read MarQ Capital's important disclosures: risk warnings, liability limitations, and legal notices applicable to our investment services.",
    keywords:
      'important disclosures, risk warnings, legal notices, investment risk, liability, MarQ Capital disclosures',
    canonical: '/legal/important-disclosures',
    ogImage: defaultOgImage,
    noindex: false
  },

  modernSlavery: {
    title: 'Modern Slavery Statement - Our Commitment',
    content:
      "Read MarQ Capital's Modern Slavery and Human Trafficking Statement. Our commitment to preventing modern slavery throughout our business and supply chain.",
    keywords:
      'modern slavery statement, human trafficking, slavery prevention, corporate responsibility, supply chain',
    canonical: '/legal/modern-slavery-statement',
    ogImage: defaultOgImage,
    noindex: false
  },

  onlinePrivacyStatement: {
    title: 'Online Privacy Statement - How We Protect Your Data',
    content:
      "Read MarQ Capital's Online Privacy Statement. Learn how we collect, use, and protect your personal data in compliance with UK GDPR.",
    keywords:
      'privacy statement, data protection, personal data, GDPR, online privacy, MarQ Capital privacy',
    canonical: '/legal/online-privacy-statement',
    ogImage: defaultOgImage,
    noindex: false
  },

  recruitmentPolicyNotice: {
    title: 'Recruitment Policy Notice - Fair & Transparent Hiring',
    content:
      "Read MarQ Capital's Recruitment Policy Notice. Our commitment to fair, transparent, and non-discriminatory hiring across the organisation.",
    keywords:
      'recruitment policy, hiring policy, equal opportunities, fair recruitment, employment policy, MarQ Capital recruitment',
    canonical: '/legal/recruitment-policy-notice',
    ogImage: defaultOgImage,
    noindex: false
  },

  // Internal Pages
  sitemap: {
    title: 'Site Navigation Map',
    content:
      'Internal site navigation map for MarQ Capital website development and testing.',
    keywords: 'sitemap, navigation, MarQ Capital pages',
    canonical: '/sitemap',
    ogImage: defaultOgImage,
    noindex: true
  },

  // 404 Not Found Page
  notFound: {
    title: 'Page Not Found',
    content:
      'The page you are looking for could not be found. Return to MarQ Capital homepage or explore our investment services and portfolio management.',
    keywords: 'page not found, 404 error, MarQ Capital navigation',
    canonical: '/404',
    ogImage: defaultOgImage,
    noindex: true, // Don't index 404 pages
    nofollow: true
  }
};

// Dynamic SEO data generators
export const generateArticleSEO = article => ({
  title: article.title,
  content: article.excerpt || article.description,
  keywords: article.tags ? article.tags.join(', ') : '',
  canonical: `/news/${article.slug}`,
  ogType: 'article',
  structuredData: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt || article.description,
    image: article.image
      ? `https://mqcapital.co.uk${article.image}`
      : 'https://mqcapital.co.uk/og-image.jpg',
    author: {
      '@type': 'Organization',
      name: 'MarQ Capital Limited'
    },
    publisher: {
      '@type': 'Organization',
      name: 'MarQ Capital Limited',
      logo: {
        '@type': 'ImageObject',
        url: 'https://mqcapital.co.uk/logo512.png'
      }
    },
    datePublished: article.publishedDate,
    dateModified: article.modifiedDate || article.publishedDate,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://mqcapital.co.uk/news/${article.slug}`
    },
    articleSection: 'Financial Services',
    keywords: article.tags ? article.tags.join(', ') : ''
  }
});

export const generateServiceSEO = service => ({
  title: `${service.name} - Professional Investment Service`,
  content: service.description,
  keywords: service.keywords || '',
  canonical: `/services/${service.slug}`,
  ogType: 'website',
  structuredData: {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: service.name,
    description: service.description,
    provider: {
      '@type': 'Organization',
      name: 'MarQ Capital Limited'
    },
    areaServed: {
      '@type': 'Country',
      name: 'United Kingdom'
    },
    serviceType: 'Financial Service'
  }
});

export default seoData;
